"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Member = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const MemberType_1 = require("./MemberType");

class Member {
  /**
   * @class
   * @description Creates a new Member for use.
   *
   * @param {Object} [options] - Member instance settings
   * @param {String} [options.id] - Member's ID
   * @param {Boolean} [options.editable] - Member is editable
   * @param {Boolean} [options.inTarget] - Member is inTarget (e.g., for autocomplete)
   * @param {Object} [options.licenseGroups] - Member's licenseGroups
   * @param {Object} [options.productRole] - Member's productRole
   * @param {String} [options.type] - Member's type
   */
  constructor(options = {}) {
    this.id = options.id;
    this.editable = options.editable;
    this.inTarget = options.inTarget;
    this.licenseGroups = options.licenseGroups;
    this.productRole = options.productRole;
    this.type = options.type;
  }
  /** Public methods **/

  /**
   * @description Method to retrieve the display name of this Member.
   *
   * @throws Not Implemented Error.
   */


  getDisplayName() {
    throw new Error(`Not Implemented: ${this}`);
  }
  /**
   * @description Method to retrieve the MemberType of the member
   *
   * @returns {MemberType} type of the member
   */


  getType() {
    return new MemberType_1.MemberType(this.type, this.id);
  }
  /**
   * @description Method to determine if this Member has a display name
   *
   * @returns {Boolean} true if the Member has a display name, else false
   */


  hasDisplayName() {
    return false;
  }
  /**
   * @description Method to determine if this Member is a new one or not.
   *
   * @returns {Boolean} true if a new Member, else false
   */


  isNew() {
    return this.id == null;
  }

}

exports.Member = Member;